import React, { useState } from "react";
import configData from "../../config.json";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  CircularProgress,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { GiSwan } from "react-icons/gi";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from "../../utils/auth"


function WifiDataDialog({ item }) {
  const params = useParams();
  const navigate = useNavigate();
  const [songTrigger, setSongTrigger] = useState(null);
  const [openWifiNetworks, setOpenWifiNetworks] = useState(false);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const handleOpenWifiNetworks = () => {
    console.log("click", openWifiNetworks);
    setOpenWifiNetworks(true);
  };

  const handleCloseWifiNetworks = () => {
    setOpenWifiNetworks(false);
  };
  const swanClick = () => {
    setSongTrigger({ response: "Loading" });
    const token = getToken()
    let device_id = item.serial_number;
    let newBody = {
      tablets: [device_id],
      message: "Trigger swan song",
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/Trigger/SwanSong`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setSongTrigger(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const handleSeeResultClick = () => {
    navigate(`/SwanSong/` + item.serial_number);
  };
  return (
    <>
      <div
        className="list-group-item list-group-item-action flex-column align-items-start"
        key={item.serial_number}
      >
        <div className="d-flex w-100 justify-content-between">
          <Button
            onClick={handleOpenWifiNetworks}
            style={{ textAlign: "left" }}
            variant="text"
          >
            {" "}
            <h5 className="mb-1">{item.serial_number}</h5>
          </Button>
          <Dialog open={openWifiNetworks} onClose={handleCloseWifiNetworks}>
            <DialogTitle>WiFi networks for {item.serial_number}</DialogTitle>
            <DialogContent>
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        <strong>Network Name</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Signal Strength</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {item.length !== 0 && (
                    <TableBody>
                      {item.networks.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell align="center">{row.ssid}</TableCell>
                          <TableCell align="center">
                            {" "}
                            {row.level < -80 ? (
                              <>
                                {" "}
                                <span
                                  className="material-symbols-outlined"
                                  style={{
                                    color: "red",
                                  }}
                                >
                                  signal_wifi_0_bar
                                </span>{" "}
                                <span>{row.level}</span>
                              </>
                            ) : row.level >= -80 && row.level < -70 ? (
                              <>
                                {" "}
                                <span
                                  className="material-symbols-outlined"
                                  style={{ color: "orange" }}
                                >
                                  network_wifi_1_bar
                                </span>
                                <span>{row.level}</span>
                              </>
                            ) : row.level >= -70 && row.level < -67 ? (
                              <>
                                {" "}
                                <span
                                  className="material-symbols-outlined"
                                  style={{ color: "yellow" }}
                                >
                                  network_wifi_2_bar
                                </span>
                                <span>{row.level}</span>
                              </>
                            ) : row.level >= -67 && row.level < -30 ? (
                              <>
                                {" "}
                                <span
                                  className="material-symbols-outlined"
                                  style={{ color: "lime" }}
                                >
                                  network_wifi_3_bar
                                </span>
                                <span>{row.level}</span>
                              </>
                            ) : (
                              <>
                                {" "}
                                <span
                                  className="material-symbols-outlined"
                                  style={{ color: "green" }}
                                >
                                  signal_wifi_4_bar
                                </span>
                                <span>{row.level}</span>
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseWifiNetworks}>Cancel</Button>
            </DialogActions>
          </Dialog>
          <small className="text-muted" style={{ marginTop: "2vh" }}>
            {" "}
            {item.connection === "WIFI" ? (
              <span
                className="material-symbols-outlined"
                style={{ color: "green" }}
              >
                wifi
              </span>
            ) : item.connection === "4G" ? (
              <span
                className="material-symbols-outlined"
                style={{ color: "orange" }}
              >
                4g_mobiledata
              </span>
            ) : (
              <span
                className="material-symbols-outlined"
                style={{ color: "red" }}
              >
                signal_cellular_nodata
              </span>
            )}
          </small>
          <Button variant="outlined" size="small" onClick={swanClick}>
            <GiSwan style={{ fontSize: "42px", color: "black" }} />
          </Button>
          {songTrigger && (
            <>
              {songTrigger.response === "Loading" ? (
                <CircularProgress size={16} />
              ) : songTrigger.response === "Success" ? (
                <Button onClick={handleSeeResultClick}>See result</Button>
              ) : (
                <Button onClick={handleSeeResultClick}>Failed</Button>
              )}
            </>
          )}
        </div>
        <small className="text-muted">
          {moment(item.ts).format("HH:mm:ss")}
        </small>{" "}
        |{" "}
        <small className="text-muted" style={{ fontSize: "12px" }}>
          {item.ssid} {item.level}
        </small>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default WifiDataDialog;
